import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
}

html,
body {
  font-size: 16px;
  line-height: 1.3;
  background: var(--color-background);
  padding-top: 0;
  font-family: 'Open Sans', Helvetica, sans-serif, SignaWeb-Light;
  height: 100%;
}

.environment-info-banner {
    align-items: center;
    column-gap: 4px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    height: 50px;
    justify-content: center;
    padding: 4px;
    width: 100%;
  }

  .environment-info-development-banner {
    background-color: var(--color-surface);
    border: 2px solid var(--color-surface-border);
    color: var(--color-on-surface);
  }

  .environment-info-test-branch-banner {
    background-color: var(--color-info-background);
    border: 2px solid var(--color-info-accent);
    color: var(--color-on-surface);
  }

.container {
  display: flex;
  flex-direction: column;
}

.App {
  margin: 0 auto;
  padding: 0px 24px 72px;
  width: 100%;
  max-width: 1128px;
  flex-grow: 1;
  min-height: calc(80vh);
}

.App-narrowContainer {
  max-width: 1080px;
  margin: 0 auto;
}

pre {
  font-size: 14px;
  font-family: monospace;
  font-weight: normal;
}

label {
  font-weight: normal;
}

fieldset,
legend {
  border: 0;
}

button {
  cursor: pointer;
}

input,
select,
textarea {
  font-size: initial;
  font-family: 'Open Sans', sans-serif;
}

fieldset {
  padding: 0;
}

button {
  color: inherit;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  font-weight: 400;
}

h4 {
  font-weight: 600;
}

blockquote {
  border-left: 5px solid #ccc;
  margin: 1.5em 10px;
  padding: 0.5em 10px;
}

.dsm-heading1 {
  color: #000000;
  font-size: 32px;
  font-family: SignaWeb-Light, sans-serif;
}

.dsm-heading1--white {
  color: white;
}

.dsm-heading2 {
  color: #000000;
  font-family: SignaWeb-Light, sans-serif;
  font-size: 26px;
  line-height: 40px;
}

.dsm-heading3 {
  color: #282828;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
}

.dsm-subtitle1 {
  font-size: 18px;
  color: #282828;
}

.dsm-subtitle1--white {
  color: white;
}

.dsm-form-label-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  font-weight: 600;
}

.dsm-form-label-text--thin {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
}

.dsm-form-hint {
  color: #000000;
  font-size: 14px;
  padding: 8px 0px;
}

.dsm-page-title {
  min-width: 45%;
}

.dsm-page-title--black {
  background: rgba(0, 0, 0, 0.7);
  padding: 24px;
}

@media (max-width: 767px) {
  body {
    font-size: 14px;
  }

  .dsm-heading3 {
    font-size: 16px;
  }

  .dsm-subtitle1 {
    font-size: 16px;
  }
}

@media (max-width: 599px) {
  .dsm-heading1 {
    font-size: 26px;
    line-height: 32px;
  }

  .dsm-heading2 {
    font-size: 22px;
    line-height: 32px;
  }
}

/*
  DatePicker fix
  Without this the datepicker is covered by the footer.
  Higher z-index on datepicker did not work.
*/
footer#brick {
  z-index: 0 !important;
}

/* Make the chat button a bit smaller on mobile devices */
@media (max-width: 500px) {
  .App {
    padding: 0px 16px 72px;
  }

  .minimizedChat {
    height: 60px !important;
    width: 54px !important;
  }
}

@media print {
  .minimizedChat {
    display: none;
  }
}

input[type='radio'] {
  margin: 0;
  padding: 0;
}

.paragraphs-of-text p + p {
  margin-top: 1rem;
}

/**
 * Don't display our app until the menu has loaded
 *
 * Hiding with CSS will let React continue rendering
 * our app in parallel.
 *
 * This avoids an ugly flash when the menu potentially
 * loads slower than the app. This is also a trick
 * to make the entire page look like _one_ coherent unit - and
 * not a bunch of different things stitched together, popping in
 * here and there.
 */
.menu-loading #root {
  display: none;
}

/**
 * This needs to stay in sync with the external menu.
 *
 * At the time of writing, this is the only way to avoid
 * a very janky menu entrance. The time delta between the external
 * menu app injects itself onto #menu and the time it actually
 * renders some content can be severe, causing a pretty bad UX.
 * During this period the menu effectively have a height of 0px.
 * 
 * @StartMenuHack
 */
#menu {
  height: 70px;
}

@media (max-width: 647px) {
  #menu {
    height: 55px;
  }
}

/* Hotjar */
.feedback > div {
  float: left;
    > div  {
      padding: 0;

      > div > div > div {
        padding-left: 0 !important;
        box-shadow: none !important;
      }
    }
  }
.feedback ._hj-widget-container ._hj-5vKq2__styles__surveyContainer._hj-7Itnd__styles__inline {
  box-shadow: none !important;
  padding-left: 0 !important;
}

._hj-sTf29__styles__inlineWrapper{
  padding-left: 0 !important;
}

[class*="surveySkipButton"] {
    display:none !important;
  }

/* End Hotjar */

/* @EndMenuHack */
`;

export default GlobalStyle;
